import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const PlatformSettingsApi = () => {
	return <PlaceholderView pageType={PageType.PlatformSettingsApi} text="API" />;
};

export default PlatformSettingsApi;
